import { render, staticRenderFns } from "./AlertAboutDeleteDialog.vue?vue&type=template&id=02a9a9e0"
import script from "./AlertAboutDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AlertAboutDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports